import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ViewTransactionService {

  constructor(private http: HttpClient) { }

  /**
   * Gets all transactions
   * @param eventName
   * @param page
   * @param limit
   * @returns
   */
  getAllTransactions(eventName: string, page?: number, limit?: number) {
    return this.http.get(`${environment.API_BASE_URL}multisig/transactions?eventName=${eventName}&page=${page? page : ''}&limit=${limit? limit : ''}`)
  }

  /**
   * Gets pending transaction count
   * @returns
   */
  getPendingTransactionCount() {
    return this.http.get(`${environment.API_BASE_URL}multisig/transactions/pending/count`)
  }
}
